import { render, staticRenderFns } from "./TitleHeader.vue?vue&type=template&id=30294f0c&scoped=true&"
import script from "./TitleHeader.vue?vue&type=script&lang=js&"
export * from "./TitleHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30294f0c",
  null
  
)

export default component.exports